import React from 'react';
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from '../redux/store';

type Props = {
  children: React.ReactNode,
  redirect?: string
}

const PublicRouteOwner: React.FC<Props> = ({ children, redirect }) => {
  const { accessToken, role } = useSelector((state: RootState) => state.auth);

  if (accessToken) {
    if (role === "OWNER") return <Navigate to={redirect ?? "/owner"} replace />;
    if (role === "STORE") return <Navigate to={redirect ?? "/store/dashboard"} replace />;
    if (role === "ADMIN") return <Navigate to={redirect ?? "/admin"} replace />;
    if (role === "ORGANIZER") return <Navigate to={redirect ?? "/organizer"} replace />;
  }

  return <>{children}</>;
}

export default PublicRouteOwner;
